import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode, APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { APP_CONFIG, provideBits } from './app/app.provider';
import { AppConfig } from './app/config/AppConfig';
import { ApplicationConfigurationService } from './app/core/services/ApplicationConfiguration.service';
// import { provideMsal } from './app/msal.provider';
import 'reflect-metadata'; // TODO: Replace with custom decorators using built-in reflection
import { providePrimeNG } from 'primeng/config';
import { TemplateThemePreset } from './styles/templateTheme/PrimeNG/template.PrimeNG.preset';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
// import { SelectableAuthInterceptor } from "./app/core/auth.interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

// Even though TypeScript might not complain about missing extension methods, they will
// not exist in the runtime code unless imported somewhere. This is where it's done.
import { registerRuntimeExtensions } from "@template-ui/helpers/runtime-extensions";
import { provideTemplateUi } from './template-ui.provider';
import { RileyAppComponent } from '@app/riley-app/riley-app.component';
import { TerminologyService } from '@app/shared/services/terminology.service';



/*
By wrapping your extensions in a function like registerRuntimeExtensions() and calling it in main.ts, you guarantee:
  - The file is included in the build
  - The prototype methods are attached before any code tries to use them
  - Future maintainers know exactly where and when extensions are registered
*/
registerRuntimeExtensions();

//import JSON5 from 'json5'


/* This is the origianl - just call bootstrapApplication */
// bootstrapApplication(AppComponent, appConfig)
//   .catch((err) => console.error(err));

// /**
//   Extend the Response object to include a json5() method
//   so that it can be used just like the original json() method,
//   but allow JSON5 so that we can includ comments in the config file.
//   This could go in a utils folder or something but so far, this is the only place it's needed.
//   If it's needed elsewhere, then it should be moved to a more appropriate location.
// */
// declare global {
//   interface Response {
//     json5(): Promise<any>;
//   }
// }

// /**
//  * Fetch the JSON5 file and return a promise that will resolve to the JSON object. (just like the original json() method)
//  */
// Response.prototype.json5 = async function<T>(): Promise<T> {
//   const text = await this.text();
//   return JSON5.parse(text);
// };


/**
 * Set the environment configuration using the token created in main.ts.
 * @param appConfig The configuration... already filled in by main.ts
 * @param appConfigService The service that will hold the configuration
 * @returns An empty promise because that's what APP_INITIALIZER needs.
 */
function initializeAppFromConfig(appConfig: AppConfig, appConfigService: ApplicationConfigurationService) {
  console.log(`Application initialized! Environment = ${appConfig.pipeline.EnvironmentName}. Version = ${appConfig.pipeline.BuildNumber}`);
  appConfigService.setAppConfig(appConfig);

  // Set the ripple effect for PrimeNG components
  // To get the ripple effect in PrimeNG buttons, add the following the the component imports
  // ButtonModule, RippleModule,  // PrimeNG Buttons
  // primeConfig.ripple = true;

  return () => Promise.resolve(); // Just another empty promise :(
}

// Set up timeout to remove the temporary Angular Material theme which only exits to prevent console warnings.
removeTempMaterialTheme();

/* Modified to fetch the environment config file BEFORE bootstrapping the application*/

/* How this works
   1. In the angular.json file, there is a section projects\bits3.client\architect\build\configurations\the-bits-way\fileReplacements
      that replaces the environment.ts file with the environment.prod.ts file. This is done when the build is done with the --configuration=the-bits-way flag.
      which is done in the DevOps pipeline as specified in the azure-pipelines.yml file in this project.

   2. The environment.prod.ts file has the name of '??'.

   3. In the following code, if it was not built using the the-bits-way, then
      the environment.name is 'dev' so the assets/app-config.dev.json file is fetched and used to set the environment configuration.
      If the environment.name is 'prod', then the assets/app-config.prod.json file is fetched and used to set the environment configuration.
*/

/**
 *  Get the app-config.{environment.name}.json file BEFORE bootstrapping the application.
 */
fetch(`assets/app.config.json?${new Date().getTime()}`)
  .then((response: Response) => {
    return response.json();
  })
  .then((config: AppConfig) => {
    //console.log(`main.ts: fetch: config = ${config.pipeline.EnvironmentName}`);

    /* Create the application configuration, using the config returned above */
    const appConfig: ApplicationConfig = {
      /* Order matter in here */
      providers: [

        // { provide: HTTP_INTERCEPTORS, useClass: SelectableAuthInterceptor, multi: true },

        // Use the APP_CONFIG token to provide the configuration
        { provide: APP_CONFIG, useValue: config },

        // Use the APP_INITIALIZER to set the environment configuration
        {
          provide: APP_INITIALIZER
          , multi: true
          , useFactory: initializeAppFromConfig
          , deps: [APP_CONFIG, ApplicationConfigurationService,]
        },

        // Enable Entra authentication
        // provideMsal(),

        provideAnimationsAsync(),

        // PrimeNG 18 stuff
        MessageService,
        DialogService,
        providePrimeNG({
          theme: {
            preset: TemplateThemePreset,

            options: {
              darkModeSelector: '.dark-mode',
              prefix: "p",
              ripple: true,
              //  This makes it worse? Yes
              // cssLayer: {
              //   name: 'primeng',
              //   order: 'tailwindcss, primeng'
              // }
            }
          },
        }),

        // All the template-ui provider stuff in one place
        provideTemplateUi(),

        /* Use the provideBits function to provide the bits */
        provideBits(),

        // Warm the current user's server-authorized terminology map. Non-blocking: screens render
        // with caller-owned fallbacks until the map arrives, then repaint reactively.
        {
          provide: APP_INITIALIZER
          , multi: true
          , useFactory: (terminology: TerminologyService) => () => { terminology.load().subscribe(); return Promise.resolve(); }
          , deps: [TerminologyService]
        },

        // Not sure what this did cuz the docs should've been generated at build-time. Also, it's
        // provideComponentIdRoot('bits-app'),
        // {
        //   provide: APP_INITIALIZER,
        //   multi: true,
        //   deps: [TypedocIndexService],
        //   useFactory: (svc: TypedocIndexService) => () => svc.load()
        // },


      ]
    };

    // Is this right, only enable prod mode for prod?
    const isProd = config.pipeline.EnvironmentName === 'prod';
    if (isProd) {
      enableProdMode();
    }
    else {
      // For now, providing msal only for non-prod
      // appConfig.providers.push( provideMsal() );
    }

    // Start the application - passing the appConfig
    bootstrapApplication(
      RileyAppComponent
      , appConfig
    ).catch((err) => console.error(err));


  }).catch(err => console.error(`Failed to fetch app.config.json: ${err}`));


/**
 * This function removes the temporary pre-built material theme to get Material to stop emitting the 'can't find theme' message
 * in the console. But since we don't want their stupid theme, it is removed after a delay. Our theme will take over.
 */
function removeTempMaterialTheme() {

  const removeLink = (): boolean => {
    const link = document.getElementById(tempThemeLinkId);
    if (link && link.parentNode) {
      link.parentNode.removeChild(link);
      return true;
      //console.log('[Material Theme] Temporary theme removed manually');
    }

    return false;
  }

  // let tempThemeLink: HTMLLinkElement | null = null;
  const tempThemeLinkId = 'stupid-temp-link-to-get-material-to-shut-up-about-missing-theme';

  let allDone: boolean = false;
  // After a bit, remove the link
  setTimeout(() => { allDone = removeLink(); }, 100);

  // Just in case the first one missed
  setTimeout(() => {
    if (!allDone) {
      //console.log("Temp theme link not removed the first time, trying again. This might indicate a timing problem.");
      removeLink();
      // if(!allDone)
      // {
      //   console.error("Temp theme link not found, something is wrong.");
      // }
    }
  }
    , 2000);
}
